const EvaluateLayout = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/EvaluateLayout')
const ServiceEvaluate = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/ServiceEvaluate')
const ProductEvaluate = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/ProductEvaluate')
const StoreEvaluate = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/StoreEvaluate')
const VehicleRecordList = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/VehicleRecordList')
const TypeManage = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/TypeManage')
const VehicleRecordIntention = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/VehicleRecordIntention')
const VehicleRecordStatistics = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/VehicleRecordStatistics')
const AddInspection = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/AddInspection')
const VehicleNav = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/VehicleNav')
const IntelligentMaintenance = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/IntelligentMaintenance')
const WorkingTimeSetting = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/intelligentMaintenance/WorkingTimeSetting')
const ProjectSetting = () => import(/* webpackChunkName: "evaluate" */'@/components/evaluate/intelligentMaintenance/ProjectSetting')
export default {
  // name: 'evaluate',
  path: 'evaluate',
  component: EvaluateLayout,
  children: [{
    name: 'serviceEvaluate',
    path: 'serviceEvaluate',
    component: ServiceEvaluate,
    meta: {
      module: 'evaluate',
    },
  }, {
    name: 'productEvaluate',
    path: 'productEvaluate',
    component: ProductEvaluate,
    meta: {
      module: 'evaluate',
    },
  }, {
    name: 'storeEvaluate',
    path: 'storeEvaluate',
    component: StoreEvaluate,
    meta: {
      module: 'evaluate',
    },
  }, {
    name: 'intelligentMaintenance',
    path: 'intelligentMaintenance',
    component: IntelligentMaintenance,
    children: [{
      name: 'intelligentMaintenance',
      path: 'intelligentMaintenance',
      component: WorkingTimeSetting,
      meta: {
        module: 'evaluate',
      },
    }, {
      name: 'projectSetting',
      path: 'intelligentMaintenance/ProjectSetting',
      component: ProjectSetting,
      meta: {
        module: 'evaluate',
      },
    }],
  }, {
    name: 'VehicleNav',
    path: 'VehicleNav',
    component: VehicleNav,
    children: [{
      name: 'VehicleRecordList',
      path: 'VehicleRecordList',
      component: VehicleRecordList,
      meta: {
        module: 'evaluate',
      },
    }, {
      name: 'TypeManage',
      path: 'TypeManage',
      component: TypeManage,
      meta: {
        module: 'evaluate',
      },
    }, {
      name: 'VehicleRecordStatistics',
      path: 'VehicleRecordStatistics',
      component: VehicleRecordStatistics,
      meta: {
        module: 'evaluate',
      },
    }, {
      name: 'VehicleRecordIntention',
      path: 'VehicleRecordIntention',
      component: VehicleRecordIntention,
      meta: {
        module: 'evaluate',
      },
    }],
  }, {
    name: 'AddInspection',
    path: 'VehicleNav/AddInspection',
    component: AddInspection,
    meta: {
      module: 'evaluate',
    },
  }, {
    path: '/',
    redirect: {name: 'storeEvaluate'},
  }],
}



// WEBPACK FOOTER //
// ./src/router/evaluate.js